import React from 'react';

import {
  GridTableCell,
  GridTableRow,
} from '../../../../shared/components/table-components';
import { ReleaseInfo } from '../../../interfaces/ReleaseInfo';
import { ReleasePlatformCell } from './ReleasePlatformCell/ReleasePlatformCell';
import { ReleaseStatusCell } from './ReleaseStatusCell/ReleaseStatusCell';
import { ReleaseNotesCell } from './ReleaseNotesCell/ReleaseNotesCell';
import { ReleaseVideoCell } from './ReleaseVideoCell/ReleaseVideoCell';

type ReleaseRowProps = {
  release: ReleaseInfo;
};

const ReleaseRow = ({ release }: ReleaseRowProps) => {
  const { platform, releaseDate, status, shortNotes, fullNotes, videoLink } = release;

  return (
    <GridTableRow variant="row">
      <ReleasePlatformCell platform={platform} />
      <GridTableCell>{releaseDate}</GridTableCell>
      <ReleaseStatusCell status={status} />
      <ReleaseNotesCell shortNotes={shortNotes} fullNotes={fullNotes} />
      <ReleaseVideoCell videoLink={videoLink} />
    </GridTableRow>
  );
};

export { ReleaseRow };
